"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isProductOwnedAdapter = _interopRequireDefault(require("self-service-api/adapters/isProductOwnedAdapter"));

var _ProductTierOrders = _interopRequireDefault(require("self-service-api/constants/ProductTierOrders"));

var _helpers = require("self-service-api/core/utilities/helpers");

var _SynonymousProducts = _interopRequireDefault(require("self-service-api/constants/SynonymousProducts"));

var hasHigherTieredProductAdapter = function hasHigherTieredProductAdapter(_ref) {
  var merchandiseMap = _ref.merchandiseMap,
      parcels = _ref.parcels,
      merchandiseId = _ref.merchandiseId,
      _ref$merchandiseIdsTr = _ref.merchandiseIdsTreatedAsOwned,
      merchandiseIdsTreatedAsOwned = _ref$merchandiseIdsTr === void 0 ? [] : _ref$merchandiseIdsTr;

  // An array of tiered merchIds for the hub your current merchandiseId is in
  var tieredProductsGroup = _ProductTierOrders.default.filter(function (productTierOrder) {
    return productTierOrder.indexOf(merchandiseId) !== -1;
  })[0];

  if (!tieredProductsGroup) {
    return false;
  } // Index of where in the tier this merchandiseId is


  var tierIndex = tieredProductsGroup.indexOf(merchandiseId); // Of all the merchIds considered owned which accomodates legacy subscriptions, find the highest for this tier

  var highestMerchIdOwned = (0, _helpers.findIndex)(tieredProductsGroup, function (tieredMerchandiseId) {
    return merchandiseIdsTreatedAsOwned.includes(tieredMerchandiseId);
  });
  var hasHigherMerchandiseIdsTreatedAsOwned = tierIndex < highestMerchIdOwned;
  if (hasHigherMerchandiseIdsTreatedAsOwned) return true;
  var higherTieredProductGroups = tieredProductsGroup.slice(tierIndex + 1, tieredProductsGroup.length);
  var hasHigherParcel = higherTieredProductGroups.some(function (tieredMerchandiseId) {
    var isSynonymousProduct = _SynonymousProducts.default.some(function (synonymousProducts) {
      return synonymousProducts.includes(merchandiseId) && synonymousProducts.includes(tieredMerchandiseId);
    });

    return !isSynonymousProduct && (0, _isProductOwnedAdapter.default)({
      merchandiseMap: merchandiseMap,
      parcels: parcels,
      merchandiseId: tieredMerchandiseId,
      merchandiseIdsTreatedAsOwned: merchandiseIdsTreatedAsOwned
    });
  });
  return hasHigherParcel;
};

exports.default = hasHigherTieredProductAdapter;
module.exports = exports.default;